import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Foorter";
import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import News from "./pages/News";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ReadMore from "./pages/ReadMore";
import NewsDetails from "./pages/NewsDetails";

function App() {
  return (
    <Router>
      <Header />

      <MainLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/read/:date" element={<ReadMore />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsDetails />}/>
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </MainLayout>

      <Footer />
    </Router>
  );
}

export default App;
